<template>
  <div class="order-detail">
    <div class="detail-top">
      <div class="status-box">
        <img
          class="success-icon"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220406/de5611e81a4baf50c2d62191cb03a6f3.png"
          alt=""
        />
        <div class="success">已完成</div>
      </div>
      <div class="content-item">
        <div class="item-l">服务内容</div>
        <div class="item-r">{{ info.title }}</div>
      </div>
      <div class="content-item">
        <div class="item-l">支付金额</div>
        <div class="item-r">¥{{ info.fee }}</div>
      </div>
    </div>
    <div class="detail-content">
      <div class="content-item">
        <div class="item-l">支付时间</div>
        <div class="item-r">{{ info.pay_time }}</div>
      </div>
      <div class="content-item">
        <div class="item-l">使用ID</div>
        <div class="item-r">{{ info.unionid }}</div>
      </div>
      <div class="content-item">
        <div class="item-l">交易单号</div>
        <div class="item-r">{{ info.tran_id }}</div>
      </div>
      <div class="content-item">
        <div class="item-l">商户单号</div>
        <div class="item-r">{{ info.out_trade_no }}</div>
      </div>
    </div>
    <div class="detail-anno">
      <div class="anno-item" @click="copyData"  v-clipboard:copy="orderlist">
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-23/a19165d49b6fbf4197c27db12d194ceb.png"
          class="anno-icon"
        />
        对订单有疑惑
      </div>
      <div class="anno-item" @click="complain">
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-23/8193b4f8aa6c5569ab8fce683cc3892a.png"
          class="anno-icon"
        />
        投诉订单
      </div>
    </div>
    <ContactImg :visible="showContact" @hideVisible="handleContact()" />
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import { Toast } from "vant";
import { reLogin, getToken, showServiceAble } from "../../utils/common";
import ContactImg from "@/components/contactImg";

export default {
  data() {
    return {
      info: {
        title: "",
        fee: 0,
        pay_time: "",
        unionid: "",
        tran_id: "",
        out_trade_no: ""
      },
      contactUserInfo: "",
      order_id: "",
      showContact: false,
      orderlist: ''
    };
  },
  components: { ContactImg },
  methods: {
    copyData() {
      // 实现复制功能
      this.handleContact();
    },
    complain() {
      // 实现投诉功能
      let urlName = this.info.status == 0 || this.info.status == 4 ? 'report' : 'complainlist'
      this.$router.replace({
        name: urlName,
        query: {
          no: this.order_id
        }
      })
    },
    contactCallback(event) {
      // 处理联系客服事件
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    getDetail() {
      let param = {
        access_token: getToken(),
        order_id: this.order_id
      };
      questionOnly.get("/xcx/ques/v1/order/detail", param).then(res => {
        this.loading = false;
        this.refreshing = false;
        if (res.sta == 0) {
          let d = res.data;
          this.info = {
            tran_id: d.tran_id,
            out_trade_no: d.out_trade_no,
            pay_time: d.pay_time,
            unionid: d.unionid,
            title: d.title,
            fee: d.fee,
            status: d.status
          };
          this.orderlist = `服务内容: ${d.title}\n支付时间: ${d.pay_time}\n商户单号: ${d.out_trade_no}`
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  },
  mounted() {
    document.title = "订单详情";
    this.order_id = this.$route.query.no;
    this.getDetail();
  }
};
</script>

<style scoped>
.order-detail {
  max-width: 500px;
  min-width: 320px;
  position: relative;
  min-height: 100vh;
  margin: 0 auto;
}
.detail-top {
  background: #ffffff;
  padding: 35px 25px 5px;
}
.success {
  margin: 20px 0 40px;
  font-size: 18px;
}
.status-box {
  text-align: center;
}
.anno-icon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.item-l {
  width: 86px;
  color: #999999;
}
.content-item {
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  line-height: 21px;
}
.detail-content {
  background: #ffffff;
  padding: 15px 25px 5px;
  margin-top: 10px;
}
.detail-anno {
  background: #ffffff;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.anno-item,
.contact-btn {
  flex: 1;
  color: #576b95;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.success-icon {
  width: 45px;
  height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/orderdetail.vue